import axiosInstance from "./AxiosInstance";

// API 1: Get service callers list
export function getServiceCallerList() {
  return axiosInstance.post("/servicecaller/servicecallerList", {});
}

// API 2: Get patients by servicecaller_id
export function getServiceCallerPatientList(servicecaller_id) {
  return axiosInstance.post("/servicecaller/servicecallerPatientList", { servicecaller_id });
}

// API 3: Reassign patients
export function reassignServiceCaller(payload) {
  return axiosInstance.post("/servicecaller/servicecallerReAssigned", payload);
}